import React from 'react';
import ClassmateCard from './ClassmateCard/ClassmateCard';

const Classmates = ({students}) => {  
  return students.map((elm,idx)=><ClassmateCard name={`${elm.firstName} ${elm.lastName}`} avatar={elm.avatar} currentBadge={elm.currentBadge} key={idx}/>)
}
 
export default Classmates;